import { memo, useCallback, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { SeperateTagsDropdown } from 'basic-components';
import { AuthCompanyQuery } from 'dashboard-services/api/auth';
import Query from 'dashboard-services/api/Query';
import { DropdownService } from 'primary-components';

import getApiConfig from 'api/ApiConfig';

import { useQueries, useQueryClient } from '@tanstack/react-query';

const EMPTY_ARRAY = [];
const useGetDefaultSlacks = ({ value, getQueryBuilder }) => {
  const splitted = value !== "" ? String(value).split(",") : EMPTY_ARRAY
  const queries = useMemo(() => splitted.map(val => ({
    ...AuthCompanyQuery.QUERIES.searchSlackNames(
      getQueryBuilder,
      {
        query: val,
        size: 1
      }
    ),
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false
  })
  ), [getQueryBuilder, splitted])
  const combine = useCallback(results => ({
    data: results.map(result => result.data?.items?.[0] || undefined).filter(r => r !== undefined).map(r => ({ label: r.name, value: r.id })),
    isPending: results.some(result => result.isPending)
  }), [])
  return useQueries({
    queries,
    combine
  })
}

const Slack = ({
  value,
  onChange,
  size = undefined,
  ref,
  ...props
}) => {
  const dispatch = useDispatch(),
        getApiConfigLocal = useCallback(() => dispatch(getApiConfig()), [dispatch]),
        getQueryBuilder = useCallback(() => 
          new Query.Builder(getApiConfigLocal())
            .withFetching(false)
        , [getApiConfigLocal]),
        [slackQuery, setSlackQuery] = useState(),
        queryClient = useQueryClient(),
        { fetchNextPage: fetchMoreSlacks, isFetching: isFetchingSlacks, isFetchingNextPage: isFetchingNextPageSlacks, data: slacks } = DropdownService.useQuerySlackNames({
          queryClient,
          input: slackQuery,
          getApiConfig: getApiConfigLocal
        }),
        { data: defaultValue } = useGetDefaultSlacks({ value, getQueryBuilder })

  return (
    <SeperateTagsDropdown
        {...props}
        defaultValue={defaultValue}
        fetchNextPage={fetchMoreSlacks}
        isFetching={isFetchingSlacks || isFetchingNextPageSlacks}
        multi
        onChange={onChange}
        onInputChange={setSlackQuery}
        options={slacks}
        placeholder="Select or type slack name"
        ref={ref}
        size={size}
    />
  )
}

Slack.displayName = "Slack"

Slack.propTypes = {
  onChange: PropTypes.func.isRequired, 
  size: PropTypes.string,
  value: PropTypes.any.isRequired,
}

export default memo(Slack);